import { isValidPhoneNumber } from 'libphonenumber-js';

const EmailRegex = /^[a-zA-Z0-9._:$!%-+]+@[a-zA-Z0-9.-]+.[a-zA-Z]$/;
const TelegramRegex =
  /^@?(?=\w{5,32}\b)[a-zA-Z0-9]+(?:[a-zA-Z0-9_ ]+[a-zA-Z0-9])*$/;

export const isValidPhone = (input: string): boolean => {
  return isValidPhoneNumber(input);
};
export const isValidEmail = (input: string): boolean => {
  return EmailRegex.test(input);
};
export const isValidTelegram = (input: string): boolean => {
  return TelegramRegex.test(input);
};
